module.exports = __webpack_public_path__ + "LatoLatin-BlackItalic.95b46b887382fae4ab18.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-BlackItalic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-BlackItalic.woff2
// module chunks = styles